import { useSelector } from "react-redux";
import { ACTION } from "src/util/utils";
import { Tooltip } from "@mui/material";
import { Button } from "antd";
import { DownSquareOutlined } from "@ant-design/icons";
import { MODULE_KEY } from "./actions";
import { formatDate } from "src/util/date";

export default function filterColumns(

) {

    const { data, loading } = useSelector(
        (state: any) => state[`${MODULE_KEY}${ACTION.STATE_KEY}`]
    );

    const columns = [
        {
            header: "ID",
            accessorKey: "Id",
            enableColumnFilter: true,
            filterFn: 'contains',
            enableSorting: true,
            size: 50,
        },
        {
            header: "FILE NAME",
            accessorKey: "OriginalFileName",
            enableColumnFilter: true,
            filterFn: 'contains',
            enableSorting: true,
            size: 100,
        },
        {
            header: "UPLOADED BY",
            accessorKey: "UploadedBy",
            enableColumnFilter: true,
            filterFn: 'contains',
            enableSorting: true,
            size: 100,
        },
        {
            header: "UPLOADED DATE",
            accessorKey: "UploadedDate",
            enableColumnFilter: true,
            filterFn: 'contains',
            enableSorting: true,
            size: 100,
            Cell: ({ cell, column, table }: { cell: any, column: any, table: any }) => {
                const uploadedDate = cell.row?.original.UploadedDate;
                if (!uploadedDate || uploadedDate === "null") {
                    return "N/A";
                }
                const formattedUploadedDate = formatDate(uploadedDate);
                const globalFilterValue = table.getState().globalFilter;
                const filterValue = globalFilterValue || column.getFilterValue();

                if (filterValue && formattedUploadedDate.toLowerCase().includes(filterValue.toLowerCase())) {

                    const regex = new RegExp(`(${filterValue})`, 'gi');
                    const highlightedDate = formattedUploadedDate.replace(regex, '<span style="background-color: #FFD580;">$1</span>');

                    return <span dangerouslySetInnerHTML={{ __html: highlightedDate }} />;
                }
                return formattedUploadedDate;
            }
        },
        {
            header: "TOTAL LOCATIONS",
            accessorKey: "TotalLocations",
            enableColumnFilter: true,
            filterFn: 'contains',
            enableSorting: true,
            size: 90,
        },
        {
            header: "NEWLY ADDED",
            accessorKey: "NewlyAdded",
            enableColumnFilter: true,
            filterFn: 'contains',
            enableSorting: true,
            size: 90,
        },
        {
            header: "EXISTING LOCATIONS",
            accessorKey: "ExistingLocations",
            enableColumnFilter: true,
            filterFn: 'contains',
            enableSorting: true,
            size: 90,
        },
        {
            header: "FILE UPLOADED",
            accessorKey: "Details",
            enableColumnFilter: false,
            enableSorting: false,
            size: 150,
            Cell: ({ cell }: { cell: any }) => {
                return (
                    <div>
                        <Tooltip placement="top" title="Download File">
                            <section className="btn-wrapper">
                                <Button
                                    type="link"
                                    size="small"
                                    style={{ marginLeft: "10px", background: "#003366" }}
                                    icon={<DownSquareOutlined style={{ color: "white" }} />}
                                    href={`${cell?.row?.original.BlobPath}`} download>
                                </Button>
                            </section>
                        </Tooltip>
                    </div>
                );
            }
        }
    ];
    return { columns, data, loading };
}